/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Backstage_AudienceInputs */

const en_backstage_audience = /** @type {(inputs: Backstage_AudienceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For Tomorrow's own teams`)
};

/**
* | output |
* | --- |
* | "For Tomorrow's own teams" |
*
* @param {Backstage_AudienceInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const backstage_audience = /** @type {((inputs?: Backstage_AudienceInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Backstage_AudienceInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_backstage_audience(inputs)
});